.aw{aspect-ratio:1/1;}